import React  from 'react';
import { Typography } from "@mui/material"


const ProfessionalCovenants = ({ covenants, fontSize = 12 }) => {

    let convenio = [];
    if (covenants != null) {
        const particular = covenants.find((el) => el.isaNombre === "Particular");
        const otherCovenants = covenants.filter((el) => el.isaNombre !== "Particular");

        const sortedCovenants = otherCovenants.sort(
            (a, b) => a.isaCodigo - b.isaCodigo
        );

        convenio = sortedCovenants.map((el) => el.isaNombre).join(", ");

        if (particular) {
            convenio += `${convenio.length > 0 ? ", ": ""} ${particular.isaNombre}`;
        }
    }

    return (
        <>
            {/* <Typography style={{ fontWeight: 'bold', fontSize: fontSize }}>
                Convenios:
            </Typography>
            <Typography style={{ fontWeight: 500, fontSize: fontSize }}>
                {!covenants || covenants?.length === 0 ? `Sin convenios` : covenants.map(el => el.isaNombre).join(", ")}
            </Typography> */}
            <Typography style={{ fontWeight: 'bold', fontSize: fontSize }}>
                Convenios:
            </Typography>
            <Typography style={{ fontWeight: 500, fontSize: fontSize }}>
                {/* {!covenants || covenants?.length === 0 ? `Sin convenios` : covenants.map(el => el.isaNombre).join(", ")} */}
                {!convenio || convenio?.length === 0 ? `Sin convenios` : convenio }
            </Typography>
        </>
    )
}

export default ProfessionalCovenants;